import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73bf2814"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sv-custom-header-reset" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"8px"} }, "Reset Configuration", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sv-custom-header-field" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Set Table Fields")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "sv-custom-header-num"
}
const _hoisted_5 = {
  key: 1,
  class: "sv-custom-header-num"
}
const _hoisted_6 = { class: "sv-custom-header-arrow" }
const _hoisted_7 = { class: "sv-custom-header-group-item" }
const _hoisted_8 = { style: {"padding-left":"6px"} }
const _hoisted_9 = { style: {"padding-left":"6px"} }
const _hoisted_10 = { class: "sv-custom-header-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-right":"8px"} }, "Set Display Sequence", -1))
const _hoisted_12 = {
  class: "sv-custom-header-drag",
  style: {"padding-top":"0"}
}
const _hoisted_13 = { class: "sv-custom-header-tag" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sv_svg_icon = _resolveComponent("sv-svg-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_sv_button = _resolveComponent("sv-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    class: "sv-custom-header-modal",
    modelValue: _ctx.showModal,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showModal) = $event)),
    title: "Table Fields Configuration",
    width: "1030px",
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_sv_button, {
        default: "",
        right: "16",
        onClick: _ctx.generateTableFields
      }, {
        default: _withCtx(() => [
          _createTextVNode("Confirm")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_sv_button, {
        default: "",
        line: "",
        grey: "",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModal = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Cancel")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
          }, [
            _createVNode(_component_sv_svg_icon, {
              type: "reset",
              fontWeight: "bold",
              "font-size": "16px",
              color: "var(--main-color)"
            }),
            _hoisted_2
          ])
        ]),
        _hoisted_3,
        (_ctx.isGroupField)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.allFields, (pItem, pKey) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "sv-custom-header-group",
                key: pKey
              }, [
                _createElementVNode("span", {
                  class: "sv-custom-header-group-title",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFieldGroup && _ctx.openFieldGroup(...args)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.filedsTitleObj[pKey]), 1),
                  (_ctx.groupSelectedNums[pKey] && _ctx.groupSelectedNums[pKey].selectedNum)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_ctx.groupSelectedNums[pKey].selectedNum) + " selected)", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, "(0 selected)")),
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_sv_svg_icon, {
                      type: "arrowDown",
                      "font-size": "16px",
                      color: "#393939"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _ctx.selectedFields,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedFields) = $event)),
                    class: "sv-custom-header-check",
                    onChange: _ctx.getAllSelectedFiledsNum
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFields[pKey], (item, key) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          label: key,
                          key: key,
                          class: "sv-custom-header-check-item"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(key), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onChange"])
                ])
              ]))
            }), 128))
          : (_openBlock(), _createBlock(_component_el_checkbox_group, {
              key: 1,
              modelValue: _ctx.selectedFields,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedFields) = $event)),
              class: "sv-custom-header-check",
              style: {"margin-top":"0"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFields, (item, key) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    label: key,
                    key: key,
                    class: "sv-custom-header-check-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_tooltip, { content: "Drag to change the display order of the fields." }, {
            default: _withCtx(() => [
              _createVNode(_component_sv_svg_icon, {
                class: "sv-custom-header-warn",
                type: "warning",
                fontWeight: "bold",
                "font-size": "16px",
                color: "var(--main-color)"
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_draggable, {
            modelValue: _ctx.selectedFields,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedFields) = $event)),
            "item-key": "id"
          }, {
            item: _withCtx(({ element }) => [
              _withDirectives(_createElementVNode("span", _hoisted_13, [
                _createElementVNode("span", null, _toDisplayString(element), 1),
                _createVNode(_component_sv_svg_icon, {
                  class: "sv-custom-header-tag-delete",
                  type: "close",
                  fontWeight: "bold",
                  "font-size": "14px",
                  color: "#fff",
                  onClick: ($event: any) => (_ctx.deleteTableField(element))
                }, null, 8, ["onClick"])
              ], 512), [
                [_vShow, element !== 'Selection' && element !== 'Operation']
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}